import React from 'react';
import {Button as NativeButton} from 'native-base';
import {message} from './../../utils/messages';

interface Props {
  label: string;
  mt?: string;
  onPress: () => void;
  disabled?: boolean;
}

const Button = (props: Props) => {
  const {label, mt, onPress: handleOnPress, disabled} = props;
  return (
    <NativeButton
      mt={mt}
      width="100%"
      borderRadius="10"
      color="white"
      borderColor="#0088FF"
      borderWidth={1}
      variant={'outline'}
      _text={{
        color: '#0088FF',
        fontWeight: 'medium',
      }}
      onPress={() => handleOnPress()}
      isDisabled={disabled}>
      {message(label)}
    </NativeButton>
  );
};

export default Button;
